module.exports = __webpack_public_path__ + "img/bg-dark.14a47c43.png";